import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, AlertTriangle } from 'lucide-react';
export function PainSection() {
  const pains = ['Trámites interminables que consumen semanas de tu tiempo', 'Documentos confusos sin saber qué necesitas exactamente', 'Cero apoyo: nadie responde tus dudas cuando las tienes', 'Riesgo de clausuras, multas o cierre temporal'];
  return <section className="py-20 bg-white" data-id="element-302">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-303">
        <div className="text-center mb-12" data-id="element-304">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-305">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-306">
              ¿Te suena familiar?
            </h2>
            <p className="text-lg text-gray-600" data-id="element-307">
              La realidad de certificar tu negocio hoy en día es frustrante.
            </p>
          </motion.div>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-308">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 p-6 bg-red-50 rounded-xl border border-red-100 hover:shadow-md transition-shadow" data-id="element-309">
              <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-310" />
              <p className="text-gray-800 font-medium" data-id="element-311">{pain}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="mt-12 p-6 bg-orange-50 border-l-4 border-orange-500 rounded-r-lg flex items-start gap-4" data-id="element-312">
          <AlertTriangle className="w-8 h-8 text-orange-500 flex-shrink-0" data-id="element-313" />
          <div data-id="element-314">
            <h3 className="font-bold text-gray-900 text-lg mb-1" data-id="element-315">
              El reloj está corriendo...
            </h3>
            <p className="text-gray-700" data-id="element-316">
              Mientras esperas y te pierdes en la burocracia, tu negocio está en
              riesgo real de ser sancionado. No dejes que un trámite detenga tu
              operación.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}